import { useEffect } from 'react';

declare global {
  interface Window {
    __SITE_ANALYTICS__?: {
      baiduHmId?: string;
      gaMeasurementId?: string;
      googleSiteVerification?: string;
    };
    _hmt?: unknown[];
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function readConfig() {
  const cfg = window.__SITE_ANALYTICS__ || {};
  return {
    baiduHmId: (cfg.baiduHmId || '').trim(),
    gaMeasurementId: (cfg.gaMeasurementId || '').trim(),
    googleSiteVerification: (cfg.googleSiteVerification || '').trim(),
  };
}

/**
 * 读取 index.html 里 window.__SITE_ANALYTICS__ 配置并注入统计/验证。
 * ID 为空时不加载脚本；用运行时配置避免空字符串被打包器摇树删除。
 */
const AnalyticsBootstrap: React.FC = () => {
  useEffect(() => {
    const { baiduHmId, gaMeasurementId, googleSiteVerification } = readConfig();

    if (googleSiteVerification) {
      let meta = document.querySelector('meta[name="google-site-verification"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'google-site-verification');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', googleSiteVerification);
    }

    if (baiduHmId && !document.querySelector('script[data-analytics="baidu-hm"]')) {
      window._hmt = window._hmt || [];
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://hm.baidu.com/hm.js?${baiduHmId}`;
      script.setAttribute('data-analytics', 'baidu-hm');
      document.head.appendChild(script);
    }

    if (gaMeasurementId && !document.querySelector('script[data-analytics="ga4"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`;
      script.setAttribute('data-analytics', 'ga4');
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(...args: unknown[]) {
        window.dataLayer?.push(args);
      };
      window.gtag('js', new Date());
      window.gtag('config', gaMeasurementId);
    }
  }, []);

  return null;
};

export default AnalyticsBootstrap;
